import { render } from "./ModalNewFleet.vue?vue&type=template&id=f358cd12&scoped=true"
import script from "./ModalNewFleet.vue?vue&type=script&lang=js"
export * from "./ModalNewFleet.vue?vue&type=script&lang=js"

import "./ModalNewFleet.vue?vue&type=style&index=0&id=f358cd12&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f358cd12"]])

export default __exports__